export default class Persistor {
  static persistedKeys = JSON.parse(localStorage.getItem('persistedKeys') || '[]');
  static store(key, value) {
    localStorage.setItem(key, value);
    if(Persistor.persistedKeys.indexOf(key) === -1) {
      Persistor.persistedKeys.push(key);
      localStorage.setItem('persistedKeys', JSON.stringify(Persistor.persistedKeys));
    }
  }

  static get(key) {
    return localStorage.getItem(key)
  }

  static remove(key) {
    return localStorage.removeItem(key)
  }

  static removeAll() {
    JSON.parse(Persistor.get('persistedKeys')).forEach((key) => {
      Persistor.remove(key);
    });
    Persistor.remove('persistedKeys');
    Persistor.persistedKeys = [];
  }
}
